const styles = () => ({
  container: {
    paddingBottom: '14px',
    marginBottom: '12px',
    borderBottom: '1px solid #e5e5e5',
    '&:last-child': {
      border: 'none'
    }
  }
})

export default styles
